import { createContext, useMemo } from "react";
import { useServiceData } from "@RequestFormV2/sections/Service/context/useServiceData";
import { useServiceHandlers } from "@RequestFormV2/sections/Service/context/useServiceHandlers";

type ServiceContextType = ReturnType<typeof useServiceData> & ReturnType<typeof useServiceHandlers>;

const ServiceContext = createContext<ServiceContextType | null>(null);

function ServiceProvider({ children }: { children: React.ReactNode }) {
  const data = useServiceData();
  const handlers = useServiceHandlers(data.freightModesConfig, data.serviceDetailsConfig, data.serviceTypeOptions);

  const value = useMemo(() => ({ ...data, ...handlers }), [data, handlers]);

  return <ServiceContext.Provider value={value}>{children}</ServiceContext.Provider>;
}

export { ServiceContext, ServiceProvider };
